import { render, staticRenderFns } from "./SageIndex.vue?vue&type=template&id=8e0365b8&"
import script from "./SageIndex.vue?vue&type=script&lang=js&"
export * from "./SageIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/easy_dev/extranet/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8e0365b8')) {
      api.createRecord('8e0365b8', component.options)
    } else {
      api.reload('8e0365b8', component.options)
    }
    module.hot.accept("./SageIndex.vue?vue&type=template&id=8e0365b8&", function () {
      api.rerender('8e0365b8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/vente-creance/sage/SageIndex.vue"
export default component.exports